<rezolve-basic-button
  [type]="type"
  [classList]="buttonClass"
  [disabled]="disabled"
  [prefixIcon]="prefixIcon"
  [suffixIcon]="suffixIcon"
  (handleClick)="onClick($event)"
  ><ng-content></ng-content
></rezolve-basic-button>
